type Placement = 'top' | 'bottom' | 'left' | 'right';

interface Position {
  top: number;
  left: number;
}

interface ArrowPosition {
  left: string;
  top: string;
}

export const removeHighlightClasses = (element: HTMLElement | null) => {
  if (element) {
    element.classList.remove('wizard-highlight');
    element.classList.remove('wizard-highlight-relative');
    element.style.position = '';
    element.style.zIndex = '';
  
    let ancestor = element.parentElement;
    while (ancestor && ancestor !== document.body) {
      ancestor.classList.remove('wizard-ancestor-boost');
      ancestor = ancestor.parentElement;
    }
  }
};

export const calculatePopoverPosition = (
  targetRect: DOMRect,
  popoverRect: DOMRect,
  placement: Placement
): Position => {
  let top = 0;
  let left = 0;
  const offset = 16;

  switch (placement) {
    case 'top':
      top = targetRect.top - popoverRect.height - offset;
      left = targetRect.left + targetRect.width / 2 - popoverRect.width / 2;
      break;
    case 'bottom':
      top = targetRect.bottom + offset;
      left = targetRect.left + targetRect.width / 2 - popoverRect.width / 2;
      break;
    case 'left':
      top = targetRect.top + targetRect.height / 2 - popoverRect.height / 2;
      left = targetRect.left - popoverRect.width - offset;
      break;
    case 'right':
      top = targetRect.top + targetRect.height / 2 - popoverRect.height / 2;
      left = targetRect.right + offset;
      break;
  }

  // Keep popover within viewport
  const padding = 16;
  const adjustedTop = Math.max(padding, Math.min(top, window.innerHeight - popoverRect.height - padding));
  const adjustedLeft = Math.max(padding, Math.min(left, window.innerWidth - popoverRect.width - padding));

  return { top: adjustedTop, left: adjustedLeft };
};

export const calculateArrowPosition = (
  arrowTargetElement: Element,
  adjustedLeft: number,
  adjustedTop: number,
  popoverRect: DOMRect,
  placement: Placement
): ArrowPosition => {
  let arrowLeft = '50%';
  let arrowTop = '50%';

  const arrowTargetRect = arrowTargetElement.getBoundingClientRect();

  if (placement === 'top' || placement === 'bottom') {
    const targetCenterX = arrowTargetRect.left + arrowTargetRect.width / 2;
    const arrowOffset = targetCenterX - adjustedLeft;
    arrowLeft = `${Math.max(20, Math.min(arrowOffset, popoverRect.width - 20))}px`;
  } else if (placement === 'left' || placement === 'right') {
    const targetCenterY = arrowTargetRect.top + arrowTargetRect.height / 2;
    const arrowOffset = targetCenterY - adjustedTop;
    arrowTop = `${Math.max(20, Math.min(arrowOffset, popoverRect.height - 20))}px`;
  }

  return { left: arrowLeft, top: arrowTop };
};
